import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ArticleAuthorMeta, getCollectionPath, sanitizeKBHtml } from './publicKB.helpers';

export default function PublicKBArticle({ brandId, article }) {
  return (
    <Stack spacing={2.5}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ color: 'rgba(255,255,255,0.82)', fontSize: 14 }}>
        <Button component={RouterLink} to={`/knowledge-base/${brandId}`} sx={{ color: '#fff', p: 0, minWidth: 'auto', fontWeight: 800 }}>
          All Collections
        </Button>
        <ChevronRightIcon fontSize="small" />
        <Button
          component={RouterLink}
          to={article.collection_slug ? getCollectionPath(brandId, article.collection_slug) : `/knowledge-base/${brandId}`}
          sx={{ color: '#fff', p: 0, minWidth: 'auto', fontSize: 14, fontWeight: 800 }}
        >
          {article.collection_name || 'General'}
        </Button>
        <ChevronRightIcon fontSize="small" />
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', fontSize: 14 }}>{article.title}</Typography>
      </Stack>

      <Card sx={{ minHeight: 560, p: { xs: 3, md: 6 }, borderRadius: 1, border: '1px solid #e5e7eb', boxShadow: 'none' }}>
        <Button
          component={RouterLink}
          to={article.collection_slug ? getCollectionPath(brandId, article.collection_slug) : `/knowledge-base/${brandId}`}
          startIcon={<ArrowBackIcon />}
          sx={{ color: 'text.primary', mb: 3 }}
        >
          Back
        </Button>
        <Box sx={{ maxWidth: 720, mx: 'auto' }}>
          <Typography variant="h2" sx={{ color: 'text.primary', fontWeight: 900, letterSpacing: 0, mb: 2 }}>
            {article.title}
          </Typography>
          <ArticleAuthorMeta article={article} />
          <Box
            sx={{
              color: '#111827',
              fontSize: 18,
              lineHeight: 1.85,
              mt: 4,
              '& h1': { color: 'text.primary', fontSize: { xs: 34, md: 44 }, lineHeight: 1.12, letterSpacing: 0, mb: 2 },
              '& h2': { color: 'text.primary', fontSize: { xs: 25, md: 30 }, lineHeight: 1.25, mt: 4, mb: 1.5 },
              '& h3': { color: 'text.primary', fontSize: 22, mt: 3, mb: 1 },
              '& p': { mb: 2 },
              '& ul, & ol': { pl: 3, mb: 2 },
              '& li': { mb: 0.75 },
              '& a': { color: 'primary.main', fontWeight: 700, textDecoration: 'none' },
              '& a:hover': { textDecoration: 'underline' },
              '& img': { maxWidth: '100%', borderRadius: 3, my: 2 },
              '& blockquote': {
                borderLeft: (theme) => `4px solid ${theme.palette.primary.main}`,
                pl: 2,
                color: 'text.secondary',
                my: 2,
              },
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeKBHtml(article.content) }}
          />
        </Box>
      </Card>
    </Stack>
  );
}
